// extracted by mini-css-extract-plugin
export default {"component":"WidgetTitle_component__xoxRT"};